"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  toNumber: true
};
exports.toNumber = void 0;
var _durationString = require("./durationString");
Object.keys(_durationString).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _durationString[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _durationString[key];
    }
  });
});
var _phoneNumber = require("./phoneNumber");
Object.keys(_phoneNumber).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _phoneNumber[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _phoneNumber[key];
    }
  });
});
/* eslint-disable import/prefer-default-export */

var toNumber = exports.toNumber = function toNumber(value) {
  if (typeof value === 'undefined' || value === null || (value == null ? void 0 : value.length) === 0) {
    return null;
  }
  return Number(value);
};